import { formatWeekRange, isCurrentWeek } from '@/lib/dateUtils'

interface WeekNavigatorProps {
  weekStart: Date
  weekEnd: Date
  onPrev: () => void
  onNext: () => void
  onToday: () => void
}

export function WeekNavigator({ weekStart, weekEnd, onPrev, onNext, onToday }: WeekNavigatorProps) {
  const isCurrent = isCurrentWeek(weekStart)

  return (
    <div className="flex items-center gap-2">
      <button
        onClick={onPrev}
        className="p-1.5 rounded-lg bg-pitch-800 text-slate-300 hover:bg-pitch-700 hover:text-white transition-colors"
        aria-label="Previous week"
      >
        <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
        </svg>
      </button>

      <span className="text-sm text-slate-300 font-medium min-w-[11rem] text-center">
        {formatWeekRange(weekStart, weekEnd)}
      </span>

      <button
        onClick={onNext}
        disabled={isCurrent}
        className="p-1.5 rounded-lg bg-pitch-800 text-slate-300 hover:bg-pitch-700 hover:text-white disabled:opacity-40 disabled:cursor-default transition-colors"
        aria-label="Next week"
      >
        <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
        </svg>
      </button>

      {!isCurrent && (
        <button
          onClick={onToday}
          className="px-2.5 py-1 rounded-lg text-xs font-medium bg-accent/20 text-accent hover:bg-accent/30 transition-colors"
        >
          Today
        </button>
      )}
    </div>
  )
}
